import {
  styled,
  TextField as MuiTextField,
  type TextFieldProps,
} from '@mui/material';

export const TextFieldLabelCustomStyles = styled('label')(({ theme }) => ({
  marginBottom: theme.spacing(1),
  display: 'inline-block',
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary,
}));

export type TextFieldCustomProps = TextFieldProps & {
  label?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
};

/**
 * TextFieldCustom component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @param {TextFieldProps} props - The props for the TextFieldCustom component.
 */

export const TextFieldCustom = ({ ...props }: TextFieldCustomProps) => {
  return (
    <MuiTextField
      sx={{
        '& .MuiFormHelperText-root': {
          marginLeft: 0,
        },
      }}
      {...props}
    />
  );
};
